import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import { close, selectAlerter, setRedirectTo } from '../../reducer/alerterSlice';
import { useAppDispatch, useAppSelector } from '../../reducer/hooks';

export default function Alerter() {
  const state = useAppSelector(selectAlerter);
  const { redirectTo, open, autoHideDuration, severity, text } = state;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo);
      dispatch(setRedirectTo(''));
    }
  }, [redirectTo]);

  const handleClose = (event: React.SyntheticEvent<any> | Event, reason: string) => {
    if (reason !== 'clickaway') {
      dispatch(close());
    }
  };

  return (
    <Snackbar
      key={text}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={() => dispatch(close())}
        severity={severity}
      >
        {text}
      </Alert>
    </Snackbar>
  );
}
